import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useDispatch } from 'react-redux';
import { setUser } from '../features/auth/authSlice';

const UserSync = ({ children }) => {
  const dispatch = useDispatch();
  const { user, isAuthenticated, isLoading } = useAuth0();

  // Sync Auth0 user to Redux
  useEffect(() => {
    if (!isLoading) {
      if (isAuthenticated && user) {
        // Transform Auth0 user to match your expected format
        const transformedUser = {
          ...user,
          // Map Auth0 properties to maintain compatibility
          preferred_username: user.username,
          roles: user['/roles'] || 
                user.roles || 
                user['custom:roles'] || 
                user.app_metadata?.roles ||
                []
        };
        dispatch(setUser(transformedUser));
      } else {
        dispatch(setUser(null));
      }
    }
  }, [isLoading, isAuthenticated, user, dispatch]);

  return children;
};

export default UserSync;